module.exports = __webpack_public_path__ + "static/media/house-3.1d01a7c8.jpeg";